import type { ReactNode } from "react";
import { Badge } from "@/components/ui/badge";
import { PermissionGroupList } from "./PermissionGroupList";
import { formatArabicNumber } from "@/lib/formatters";

interface PermissionScopeSectionProps {
  title: string;
  description: string;
  permissions: string[];
  activeCount: number;
  isActive: (permission: string) => boolean;
  renderControl: (permission: string) => ReactNode;
  renderMeta?: (permission: string) => ReactNode;
  onResetGroup?: (permissions: string[]) => void;
}

export function PermissionScopeSection({
  title,
  description,
  permissions,
  activeCount,
  isActive,
  renderControl,
  renderMeta,
  onResetGroup,
}: PermissionScopeSectionProps) {
  return (
    <section className="space-y-3 rounded-lg border bg-card p-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <Badge variant="secondary" className="tabular-nums">
          {formatArabicNumber(activeCount)} / {formatArabicNumber(permissions.length)}{" "}
          مفعّلة
        </Badge>
        <div className="text-right">
          <h3 className="text-sm font-semibold text-foreground">{title}</h3>
          <p className="text-xs text-muted-foreground">{description}</p>
        </div>
      </div>

      <PermissionGroupList
        permissions={permissions}
        isActive={isActive}
        renderControl={renderControl}
        renderMeta={renderMeta}
        onResetGroup={onResetGroup}
      />
    </section>
  );
}
